const INSTRUCTIONS_SERVICE = 'https://instructions.documents.cimpress.io';
export function getInstructionsServiceUrl() {
  return "".concat(INSTRUCTIONS_SERVICE, "/v3/instructions:preview");
}
export function getItemInstructionsServiceUrl() {
  return "".concat(INSTRUCTIONS_SERVICE, "/v3/instructions:item");
}
export function buildInstructionsUrl(_ref) {
  let {
    cimDocUrl,
    surfaceOrdinals,
    ignoreProjection,
    instructionsServiceUrl = getInstructionsServiceUrl(),
    slotNumberOverrides
  } = _ref;
  const url = new URL(instructionsServiceUrl);
  url.searchParams.set('documentUri', cimDocUrl);
  if (surfaceOrdinals) {
    url.searchParams.set('surfaceOrdinals', "".concat(surfaceOrdinals));
  }
  if (ignoreProjection) {
    url.searchParams.set('ignoreProjection', "".concat(ignoreProjection));
  }
  if (slotNumberOverrides) {
    const slotNumberOverridesString = Object.entries(slotNumberOverrides).map(_ref2 => {
      let [slotNumber, slotNumberOverride] = _ref2;
      return "".concat(slotNumber, ":").concat(slotNumberOverride);
    }).join(',');
    if (slotNumberOverridesString) {
      url.searchParams.set('slotNumberOverrides', "{".concat(slotNumberOverridesString, "}"));
    }
  }
  return url.toString();
}